<template>
    <div>
        <onboarding isSetup ref="onboarding" @on:completed="handleSetupCompleted" />
    </div>
</template>

<script>
import _ from "lodash";
import AccountService from '@/services/AccountService';
import { updateCompliance } from '@/utils/compliance';

export default {
    name: 'Setup',
    data() {
        return {
            redirectToRoute: { name: 'home.index' },
        }
    },
    mounted() {
        const { accountCompliance } = this.$store.state.account;

        if (_.isNil(accountCompliance)) {
            this.handleSetupCompleted();

            return;
        }

        const { businessConfiguredAt } = accountCompliance;

        if (_.isNil(businessConfiguredAt)) {
            this.$refs.onboarding.show();

            return;
        }

        this.handleSetupCompleted();
    },
    methods: {
        handleSetupCompleted(route = { name: 'home.index' }) {
            this.$router.push(route);
            this.save('businessConfiguredAt');
        },
        async save(complianceType) {
            const accountId = this.$store.state.account.id;
            await AccountService.updateCompliance(accountId, { ComplianceType: complianceType });
            await updateCompliance(this, complianceType);
        },
    },
}
</script>